import { render, staticRenderFns } from "./WQDataLastRecordForm.vue?vue&type=template&id=34a35af2"
import script from "./WQDataLastRecordForm.vue?vue&type=script&lang=js"
export * from "./WQDataLastRecordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports